import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmallCarIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "#A0A0A0",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3398 1.88672H5.65984C3.99984 1.88672 3.63317 2.71339 3.41984 3.72672L2.6665 7.33339H13.3332L12.5798 3.72672C12.3665 2.71339 11.9998 1.88672 10.3398 1.88672Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6598 13.212C14.7332 13.992 14.1065 14.6654 13.3065 14.6654H12.0532C11.3332 14.6654 11.2332 14.3587 11.1065 13.9787L10.9732 13.5787C10.7865 13.032 10.6665 12.6654 9.70649 12.6654H6.29316C5.33316 12.6654 5.19316 13.0787 5.02649 13.5787L4.89316 13.9787C4.76649 14.3587 4.66649 14.6654 3.94649 14.6654H2.69316C1.89316 14.6654 1.26649 13.992 1.33982 13.212L1.71316 9.15203C1.80649 8.15203 1.99982 7.33203 3.74649 7.33203H12.2532C13.9998 7.33203 14.1932 8.15203 14.2865 9.15203L14.6598 13.212Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.66667 5.33203H2",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0002 5.33203H13.3335",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 2V3.33333",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 3.33203H9",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 10H6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 10H12",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSmallCarIcon;
